import axios from "axios";
import { rest_api_url } from "../constants/urls";

const url = process.env.REACT_APP_API_URL;

export const getPartnersListAPI = async () => {
  var return_data = {};
  return new Promise((resolve, rejected) => {
    let token = localStorage.getItem("access_token");
    let refresh_token = localStorage.getItem("refresh_token");
    const headers = {
      authorization: token ? `Bearer ${token}` : refresh_token,
    };
    const type = "vendors";
    const vendors_url = `${url}/v1/get/list/${type}`;
    axios
      .get(vendors_url, { headers })
      .then((response) => {
        if (response.status === 200) {
          return_data = {
            status: true,
            response_code: 200,
            data: response.data,
          };
          return resolve(return_data);
        }
      })
      .catch((err) => {
        return_data = {
          status: false,
          response_code: err?.response?.status,
          data: err?.response?.data?.error?.message,
        };
        return resolve(return_data);
      });
  });
};

export const signInverifyMFATokenAPI = async (data) => {
  var return_data = {};
  return new Promise((resolve, rejected) => {
    axios
      .post(rest_api_url.mfa_signIn_verify, data, {})
      .then((response) => {
        if (response.status === 200) {
          return_data = {
            status: true,
            response_code: 200,
            data: response.data,
          };
          return resolve(return_data);
        }
      })
      .catch((err) => {
        return_data = {
          status: false,
          response_code: err?.response?.status,
          data: err?.response?.data?.error?.message,
        };
        return resolve(return_data);
      });
  });
};
